"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ListView = /*#__PURE__*/function (_React$Component) {
  _inherits(ListView, _React$Component);

  var _super = _createSuper(ListView);

  function ListView(props) {
    var _this;

    _classCallCheck(this, ListView);

    _this = _super.call(this, props);
    _this.state = {
      openContentTypes: {}
    };
    _this.onContentTypeClick = _this.onContentTypeClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ListView, [{
    key: "onContentTypeClick",
    value: function onContentTypeClick(contentType) {
      var openContentTypes = this.state.openContentTypes;

      if (openContentTypes[contentType.id]) {
        delete openContentTypes[contentType.id];
      } else {
        openContentTypes[contentType.id] = true;
      }

      this.setState({
        openContentTypes: openContentTypes
      });
    }
  }, {
    key: "showItem",
    value: function showItem(index, contentType) {
      var settings = this.props.settings;
      var openContentTypes = this.state.openContentTypes;
      return index < settings.maxListCount || openContentTypes[contentType.id];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ListItemViewClass = _this$props.ListItemViewClass,
          onItemClick = _this$props.onItemClick,
          settings = _this$props.settings,
          contentTypes = _this$props.contentTypes,
          dictionary = _this$props.dictionary;
      var openContentTypes = this.state.openContentTypes;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "resources outer-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "desktop-section outer-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-type-container outer-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inner-container"
      }, contentTypes.map(function (contentType) {
        var isOpen = !!openContentTypes[contentType.id];
        var hasOverflow = settings.maxListCount < contentType.filteredItems.length;
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: contentType.id,
          key: contentType.id,
          className: "content-type"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "content-type__header"
        }, /*#__PURE__*/_react["default"].createElement("h4", null, contentType.name)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "content-type-files"
        }, contentType.filteredItems.map(function (item, index) {
          return _this2.showItem(index, contentType) ? /*#__PURE__*/_react["default"].createElement(ListItemViewClass, {
            key: item.id,
            item: item,
            onItemClick: onItemClick,
            index: index
          }) : null;
        })), hasOverflow && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.onContentTypeClick(contentType);
          },
          className: "expand-button ".concat(isOpen ? 'open' : 'closed')
        }, isOpen ? dictionary.back : dictionary.viewallitems.format(contentType.filteredItems.length)));
      })))))));
    }
  }]);

  return ListView;
}(_react["default"].Component);

ListView.propTypes = {
  settings: _propTypes2["default"].settings.isRequired,
  dictionary: _propTypes2["default"].dictionary.isRequired,
  ListItemViewClass: _propTypes["default"].func.isRequired,
  contentTypes: _propTypes2["default"].contentTypes.isRequired,
  onItemClick: _propTypes["default"].func.isRequired
};
var _default = ListView;
exports["default"] = _default;